<div class="heartbeat-wrapper" matTooltip="{{ 'tooltip.heartbeatStatus' | translate }}">
  <mat-icon
    class="heartbeat-icon"
    [ngClass]="{ 'alive': isAlive, 'dead': !isAlive }">
    fiber_manual_record
  </mat-icon>
</div>
